import { BackendSubscription } from 'common/types'
import { get, useHttp } from 'hooks/use-http/useHttp'

export const fetchAllSubscriptions = async () => {
  const response: BackendSubscription[] = await get(`subscription`)
  return response
}

export const fetchSubscriptionByName = async (name: string) => {
  const response: BackendSubscription = await get(`subscription/name/${name}`, { dieSilent: true })
  return response
}

export const verifySubscriptionPromoCode = async (promoCode: string) => {
  const response: boolean = await get(`subscription/promo/${promoCode}`, { dieSilent: true })
  return response
}

export const useSubscriptionApi = () => {
  return { fetchAllSubscriptions, fetchSubscriptionByName, verifySubscriptionPromoCode } as const
}
